import styled from 'styled-components'

const StyledContainer = styled.li`
  list-style-type: none;

  margin-bottom: 0;
  border-bottom: 1px solid #f3f5fb;
  cursor: pointer;

  &:hover {
    background-color: #f3f9ff;
  }
  
  @media (max-width: 768px) {
    padding: 12px 4px 12px 0px;
  }

  @media (max-width: 420px) {
	padding: 0px;
  }
`

const StyledImage = styled.div`
  height: 100%;
  width: 100%;
  grid-row: ${props => (props.isSmall ? '1 / span 5' : '1 / span 2')};
  grid-column: 1;
  justify-self: center;
  justify-content: center;
  align-items: center;
`

const StyledItem = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: ${props => (props.isBold ? 'bold' : '500')};
  grid-row: ${props => props.gridRow};
  grid-column: ${props => props.gridColumn};
  color: ${props => (props.color ? props.color : 'unset')};
  box-sizing: border-box;
  
`

const StyledIcon = styled.div`
  justify-self: center;
  width: 40px;
  height: 40px;
  display: ${props => (props.isActive ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  grid-row: 1 / span 2;
  grid-column: ${props => (props.isSmall ? '3' : '5')};
  background: #006ee5;
  border-radius: 50%;
`

const LinkWrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: auto 2fr 2fr 2fr 50px;
  grid-column-gap: 10px;
  grid-row-gap: 0; 
  text-decoration:none;
  cursor: pointer;
  padding: 12px 8px 12px 8px;

  &:hover {
	background-color: #f3f9ff;
  }

  &:focus {
	background-color: #f3f9ff;
	outline: 3px solid #FF9900;
  }

  @media (max-width: 420px) {
	padding: 0px;
	grid-template-rows: 1fr 10px auto auto;
	padding: 8px 8px 8px 8px;
  }
`

export {StyledContainer, StyledImage, StyledIcon, StyledItem, LinkWrapper}
